module.exports = __webpack_public_path__ + "heart-classic-granite.3624701ebfe0b642f769.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/heart-classic-granite.svg
// module id = ../../../../../src/assets/img/heart-classic-granite.svg
// module chunks = main